module.exports = __webpack_public_path__ + "static/media/corrin_0.47c16fb3.png";